/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.StripePlanBean = factory(root.BpmbuildProductionappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The StripePlanBean model module.
   * @module model/StripePlanBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripePlanBean</code>.
   * @alias module:model/StripePlanBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripePlanBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripePlanBean} obj Optional instance to populate.
   * @return {module:model/StripePlanBean} The populated <code>StripePlanBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('interval'))
        obj.interval = ApiClient.convertToType(data['interval'], 'String');
      if (data.hasOwnProperty('product'))
        obj.product = ApiClient.convertToType(data['product'], 'String');
      if (data.hasOwnProperty('livemode'))
        obj.livemode = ApiClient.convertToType(data['livemode'], 'Boolean');
      if (data.hasOwnProperty('trial_period_days'))
        obj.trialPeriodDays = ApiClient.convertToType(data['trial_period_days'], 'String');
      if (data.hasOwnProperty('metaData'))
        obj.metaData = ApiClient.convertToType(data['metaData'], 'String');
      if (data.hasOwnProperty('amount'))
        obj.amount = ApiClient.convertToType(data['amount'], 'Number');
      if (data.hasOwnProperty('billing_scheme'))
        obj.billingScheme = ApiClient.convertToType(data['billing_scheme'], 'String');
      if (data.hasOwnProperty('stripePlanId'))
        obj.stripePlanId = ApiClient.convertToType(data['stripePlanId'], 'String');
      if (data.hasOwnProperty('aggregate_usage'))
        obj.aggregateUsage = ApiClient.convertToType(data['aggregate_usage'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('nickname'))
        obj.nickname = ApiClient.convertToType(data['nickname'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('tiers_mode'))
        obj.tiersMode = ApiClient.convertToType(data['tiers_mode'], 'String');
      if (data.hasOwnProperty('object'))
        obj._object = ApiClient.convertToType(data['object'], 'String');
      if (data.hasOwnProperty('interval_count'))
        obj.intervalCount = ApiClient.convertToType(data['interval_count'], 'Number');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'Date');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('transform_usage'))
        obj.transformUsage = ApiClient.convertToType(data['transform_usage'], 'String');
      if (data.hasOwnProperty('usage_type'))
        obj.usageType = ApiClient.convertToType(data['usage_type'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
    }
    return obj;
  }

  /**
   * @member {String} interval
   */
  exports.prototype.interval = undefined;

  /**
   * @member {String} product
   */
  exports.prototype.product = undefined;

  /**
   * @member {Boolean} livemode
   */
  exports.prototype.livemode = undefined;

  /**
   * @member {String} trialPeriodDays
   */
  exports.prototype.trialPeriodDays = undefined;

  /**
   * @member {String} metaData
   */
  exports.prototype.metaData = undefined;

  /**
   * @member {Number} amount
   */
  exports.prototype.amount = undefined;

  /**
   * @member {String} billingScheme
   */
  exports.prototype.billingScheme = undefined;

  /**
   * @member {String} stripePlanId
   */
  exports.prototype.stripePlanId = undefined;

  /**
   * @member {String} aggregateUsage
   */
  exports.prototype.aggregateUsage = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Boolean} active
   */
  exports.prototype.active = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {String} nickname
   */
  exports.prototype.nickname = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} tiersMode
   */
  exports.prototype.tiersMode = undefined;

  /**
   * @member {String} _object
   */
  exports.prototype._object = undefined;

  /**
   * @member {Number} intervalCount
   */
  exports.prototype.intervalCount = undefined;

  /**
   * @member {Date} created
   */
  exports.prototype.created = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {String} transformUsage
   */
  exports.prototype.transformUsage = undefined;

  /**
   * @member {String} usageType
   */
  exports.prototype.usageType = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/StripePlanBean.js